import { render } from "./lines_right.svg?vue&type=template&id=3da5f38e"
const script = {}
script.render = render

export default script